/**
 * Generate Route Parents List
 *
 * @param parentList Object listening all possible parents for a route
 * @param parents Array of string containing name of attribute in parentList object
 * @returns {*[]}
 */
const generateParentsList = (parentList, parents) => {
    return parents.map(parent => parentList[parent])
}

export {
    generateParentsList
}